import { render, staticRenderFns } from "./TagSearch.vue?vue&type=template&id=203ff07a&scoped=true&"
import script from "./TagSearch.vue?vue&type=script&lang=js&"
export * from "./TagSearch.vue?vue&type=script&lang=js&"
import style0 from "./TagSearch.vue?vue&type=style&index=0&id=203ff07a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203ff07a",
  null
  
)

export default component.exports